import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { WarehouseRestockType } from '../enums/warehouse-restock-type';

@Injectable({
  providedIn: 'root',
})
export class WarehouseRestockTypeProviderService {
  private entries = new Map<WarehouseRestockType, string>([
    [WarehouseRestockType.Return, 'Zwrot użytkownika'],
    [WarehouseRestockType.Complaint, 'Zwrot na podstawie reklamacji'],
  ]);

  public label(status: WarehouseRestockType): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${status}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<WarehouseRestockType>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
